// @ts-nocheck
import React, { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useState } from "react";

export interface ScrollContextModel {
    scroll: number;
    setScroll: (() => void) | Dispatch<SetStateAction<number>>;
}

export const defaultContext: ScrollContextModel = {
    scroll: 0,
    setScroll: () => {},
};

export const ScrollContext = createContext<ScrollContextModel>(defaultContext);

const ScrollContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [scroll, setScroll] = useState(0);

    const providerValue: ScrollContextModel = {
        scroll,
        setScroll,
    };

    return <ScrollContext.Provider value={providerValue}>{children}</ScrollContext.Provider>;
};

export default ScrollContextProvider;
